<div class="page-container">
  <div class="card p-3 m-3 position-relative">
    <!-- Bottone toggle in alto a destra -->
    <button
      type="button"
      class="position-absolute"
      style="
        top: 10px;
        right: 10px;
        border: none;
        background: none;
        padding: 0;
        margin: 0;
        line-height: 1;
      "
      (click)="showFilters = !showFilters"
      [title]="showFilters ? 'Nascondi filtri' : 'Mostra filtri'"
    >
      <i
        class="bi"
        [ngClass]="showFilters ? 'bi-chevron-up' : 'bi-chevron-down'"
        style="font-size: 1.4rem; padding: 5px"
      ></i>
    </button>

    <div class="row px-3 mb-2">
      <div class="mb-2 d-flex align-items-center gap-3">
        <h2 class="mb-0"><b>Elenco Colli Armonizzazione</b></h2>

        <!-- Totale colli -->
        <div
          class="total-parcels"
          title="Totale colli che corrispondono ai filtri"
        >
          <i class="bi bi-box-seam total-parcels-icon"></i>
          <span class="total-parcels-value">
            <span
              *ngIf="isLoadingParcels"
              class="spinner-border spinner-border-sm"
            ></span>
            <ng-container *ngIf="!isLoadingParcels">
              {{ hasSearched ? (totalRecords | number) : "–" }}
            </ng-container>
          </span>
        </div>
        <!-- <span class="status-indicator-undefined" *ngIf="!shouldHideBigOrdersToggle()">
                    <div class="custom-switch-btn d-flex align-items-center">
                        <label class="form-check-label me-2" for="showBigOrders" style="cursor: pointer;">
                        Visualizza anche Big Orders
                        </label>
                        <div class="form-check form-switch m-0" style="cursor: pointer;">
                        <input
                            style="cursor: pointer;"
                            class="form-check-input"
                            type="checkbox"
                            id="showBigOrders"
                            [(ngModel)]="showBigOrders"
                            name="showBigOrders"
                        />
                        </div>
                    </div>
                </span> -->
      </div>

      <!--
                  <div class="d-flex justify-content-between flex-wrap w-100 align-items-end"> -->

      <!-- Filtri visibili solo se showFilters è true -->
      <div *ngIf="showFilters">
        <div class="d-flex flex-wrap gap-3 mb-3">
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codice Collo"
              [(ngModel)]="searchParcelCode"
            />
          </div>
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codice Bolla"
              [(ngModel)]="searchParcelWaybillCode"
            />
          </div>
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codici DDT"
              [(ngModel)]="searchDDTCodes"
            />
          </div>
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codice Dealer"
              [(ngModel)]="searchDealerCode"
            />
          </div>
        </div>
        <div class="d-flex flex-wrap gap-3 mb-3">
          <div
            class="mb-0"
            style="min-width: 200px"
            *ngIf="filteredClients.length > 1"
          >
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
                name="clients"
                [placeholder]="'Seleziona clienti'"
                [settings]="dropdownSettingsClient"
                [data]="filteredClients"
                [(ngModel)]="selectedClients"
                [ngModelOptions]="{ standalone: true }"
                (onSelect)="onClientsChange()"
                (onDeSelect)="onClientsChange()"
                (onSelectAll)="selectAllClients()"
                (onDeSelectAll)="deselectAllClients()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="mb-0" style="min-width: 400px">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsDealer"
                name="dealers"
                [placeholder]="'Seleziona dealers'"
                [settings]="dropdownSettingsDealer"
                [data]="filteredDealers"
                [(ngModel)]="selectedDealers"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllDealers()"
                (onDeSelectAll)="deselectAllDealers()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="mb-0" style="min-width: 400px" *ngIf="canSpecial()">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsCarrier"
                name="carriers"
                [placeholder]="'Seleziona vettori'"
                [settings]="dropdownSettingsCarrier"
                [data]="filteredCarriers"
                [(ngModel)]="selectedCarriers"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllCarriers()"
                (onDeSelectAll)="deselectAllCarriers()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-0" style="min-width: 300px" *ngIf="canSpecial()">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsWarehouseFrom"
                name="warehouseFrom"
                [placeholder]="'Seleziona magazzini partenza'"
                [settings]="dropdownSettingsWarehouseFrom"
                [data]="filteredWarehousesFrom"
                [(ngModel)]="selectedWarehousesFrom"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllWarehousesFrom()"
                (onDeSelectAll)="deselectAllWarehousesFrom()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-0" style="min-width: 300px" *ngIf="canSpecial()">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsWarehouse"
                name="warehouse"
                [placeholder]="'Seleziona magazzini ultimo miglio'"
                [settings]="dropdownSettingsWarehouse"
                [data]="filteredWarehouses"
                [(ngModel)]="selectedWarehouses"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllWarehouses()"
                (onDeSelectAll)="deselectAllWarehouses()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-0" style="min-width: 200px">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsRegion"
                name="regions"
                [placeholder]="'Seleziona regioni'"
                [settings]="dropdownSettingsRegion"
                [data]="filteredRegions"
                [(ngModel)]="selectedRegions"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllRegions()"
                (onDeSelectAll)="deselectAllRegions()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-0" style="min-width: 300px" *ngIf="canSpecial()">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsTour"
                name="tours"
                [placeholder]="'Seleziona tours'"
                [settings]="dropdownSettingsTour"
                [data]="filteredTours"
                [(ngModel)]="selectedTours"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllTours()"
                (onDeSelectAll)="deselectAllTours()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-0" style="min-width: 250px">
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="dropdownSettingsStatus"
                name="parcelDetailStatus"
                [placeholder]="'Seleziona stati'"
                [settings]="dropdownSettingsStatus"
                [data]="parcelDetailStatusOptions"
                [(ngModel)]="selectedParcelDetailStatuses"
                [ngModelOptions]="{ standalone: true }"
                (onSelectAll)="selectAllStatuses()"
                (onDeSelectAll)="deselectAllStatuses()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select class="form-select" [(ngModel)]="notificationStatus">
              <option value="">Tutti i colli (notificati e non)</option>
              <option value="not_notified">Solo colli non notificati</option>
              <option value="notified">Solo colli notificati</option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="deliveryStatus">
              <option value="">Tutti i colli (consegnati e non)</option>
              <option value="not_delivered">Solo colli non consegnati</option>
              <option value="delivered">Solo colli consegnati</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select class="form-select" [(ngModel)]="modifyStatus">
              <option value="">Tutti i colli (armonizzati e non)</option>
              <option value="not_modified">Solo colli non armonizzati</option>
              <option value="modified">Solo colli armonizzati</option>
            </select>
          </div>
          <div class="mb-2">
            <select
              class="form-select"
              [(ngModel)]="onTimeStatus"
              name="onTimeStatus"
            >
              <option value="">Tutti i colli (in ritardo e non)</option>
              <option value="ON_TIME">Colli in orario</option>
              <option value="NOT_ON_TIME">Colli in ritardo</option>
              <option value="DELAY_LT_2H">▹ Colli in ritardo ≤ 2h</option>
              <option value="DELAY_2H_3H">
                ▹ Colli in 2h &lt; ritardo ≤ 3h
              </option>
              <option value="DELAY_3H_1D">
                ▹ Colli in 3h &lt; ritardo ≤ 1 giorno
              </option>
              <option value="DELAY_GT_1D">
                ▹ Colli in ritardo &gt; 1 giorno
              </option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="inRangeStatus">
              <option value="">Tutte le coordinate</option>
              <option value="NOT_IN_RANGE">Solo coordinate errate</option>
              <option value="IN_RANGE">Solo coordinate corrette</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select
              class="form-select"
              [(ngModel)]="scheduleType"
              name="scheduleType"
            >
              <option value="">Tutte (DMDC/A*B/A*C)</option>
              <option value="AxA">DMDC</option>
              <option value="AxB">A*B</option>
              <option value="AxC">A*C</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select
              class="form-select"
              [(ngModel)]="scheduleIsNight"
              name="scheduleIsNight"
            >
              <option value="">Tutte (Night/Day)</option>
              <option value="Y">Night</option>
              <option value="N">Day</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select
              class="form-select"
              [(ngModel)]="selectedDeliveryMethod"
              name="selectedDeliveryMethod"
            >
              <option value="">Tutte (via terra/aerea)</option>
              <option value="BY_ROAD">Via terra</option>
              <option value="BY_AIR">Via aerea</option>
            </select>
          </div>
          <!-- <div class="mb-2">
                      <input type="date" class="form-control" [(ngModel)]="parcelDateStart" />
                    </div>
                    <div class="mb-2">
                      <input type="date" class="form-control" [(ngModel)]="parcelDateEnd" />
                    </div> -->
          <!-- <div class="mb-2">
                      <div class="d-flex align-items-end flex-wrap">
                        <div class="d-flex">
                          <button class="btn btn-light" style="padding: 6px;" (click)="shiftCreationDates(-1)" title="Indietro di 1 giorno">
                            <i class="fa-solid fa-caret-left"></i>
                          </button>
                          <input type="date" class="form-control" [(ngModel)]="parcelDateStart" id="parcelDateStart" />
                        </div>
                        <div class="d-flex">
                          <input type="date" class="form-control" [(ngModel)]="parcelDateEnd" id="parcelDateEnd" />
                          <button class="btn btn-light" style="padding: 6px;" (click)="shiftCreationDates(1)" title="Avanti di 1 giorno">
                            <i class="fa-solid fa-caret-right"></i>
                          </button>
                        </div>
                      </div>
                    </div> -->

          <div class="mb-2 d-flex">
            <button
              class="btn btn-light shift-btn back"
              (click)="shiftCreationDates(-1)"
              title="Indietro di 1 giorno"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap align-content-center">
              <!-- Data inizio -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelDateStart" class="custom-label"
                  >Data inizio affido</label
                >
                <input
                  type="date"
                  id="parcelDateStart"
                  [(ngModel)]="parcelDateStart"
                  class="form-control no-padding-input"
                />
              </div>
              <!-- Data fine -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelDateEnd" class="custom-label"
                  >Data fine affido</label
                >
                <input
                  type="date"
                  id="parcelDateEnd"
                  [(ngModel)]="parcelDateEnd"
                  class="form-control no-padding-input"
                />
              </div>
            </div>
            <button
              class="btn btn-light shift-btn forward"
              (click)="shiftCreationDates(1)"
              title="Avanti di 1 giorno"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
          <!-- <div class="mb-2 d-flex align-items-end">
                      <button class="btn btn-primary" (click)="applyFilters()">Applica Filtri</button>
                    </div> -->

          <div class="mb-2 d-flex">
            <button
              class="btn btn-light shift-btn back"
              (click)="shiftEstimatedDates(-1)"
              title="Indietro di 1 giorno"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap align-content-center">
              <!-- Data inizio consegna stimata -->
              <div class="position-relative" style="width: 200px">
                <label
                  for="parcelEstimatedDeliveryDateStart"
                  class="custom-label"
                  >Data inizio consegna stimata</label
                >
                <input
                  type="date"
                  id="parcelEstimatedDeliveryDateStart"
                  [(ngModel)]="parcelEstimatedDeliveryDateStart"
                  class="form-control no-padding-input"
                />
              </div>
              <!-- Data fine consegna stimata -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelEstimatedDeliveryDateEnd" class="custom-label"
                  >Data fine consegna stimata</label
                >
                <input
                  type="date"
                  id="parcelEstimatedDeliveryDateEnd"
                  [(ngModel)]="parcelEstimatedDeliveryDateEnd"
                  class="form-control no-padding-input"
                />
              </div>
            </div>
            <button
              class="btn btn-light shift-btn forward"
              (click)="shiftEstimatedDates(1)"
              title="Avanti di 1 giorno"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-primary" (click)="applyFilters()">
            Applica Filtri
          </button>
          <button class="btn btn-light" type="button" (click)="resetFilters()">
            Reset
          </button>
        </div>
      </div>

      <!--
                  </div> -->
    </div>
  </div>

  <div class="row px-3 mb-3">
    <div
      class="col-12 d-flex align-items-center gap-2 flex-wrap flex-md-nowrap parcels-toolbar"
    >
      <!-- <button title="Configura colonne" class="btn btn-outline-secondary" (click)="showConfig = true">
              <i class="bi bi-gear"></i>
            </button> -->
      <!-- Pulsanti e totale allineati a destra -->
      <button
        class="btn toolbar-btn toolbar-btn-import ms-auto"
        type="button"
        (click)="openImportExcelModal()"
        title="Importa Excel Consegne"
      >
        <i class="fa-solid fa-file-import"></i>
      </button>

      <column-customize
        [(columns)]="columns"
        [storageKey]="'parcelTableConfig'"
      ></column-customize>

      <!-- Bottone Excel -->
      <button
        class="btn toolbar-btn toolbar-btn-excel"
        type="button"
        [disabled]="isExporting || !hasMinimumFilters()"
        (click)="exportParcelsToExcel()"
        [title]="hasMinimumFilters() ? 'Esporta Excel' : minimumFiltersMessage"
      >
        <span
          *ngIf="exportingType === 'standard'"
          class="spinner-border spinner-border-sm"
        ></span>
        <i *ngIf="exportingType !== 'standard'" class="fas fa-file-excel"></i>
      </button>

      <button
        *ngIf="canSpecial()"
        class="btn toolbar-btn toolbar-btn-excel"
        type="button"
        [disabled]="isExporting || !hasMinimumFilters()"
        (click)="exportParcelsOriginalToExcel()"
        [title]="
          hasMinimumFilters()
            ? 'Esporta Excel Con Dati Originali'
            : minimumFiltersMessage
        "
      >
        <span
          *ngIf="exportingType === 'original'"
          class="spinner-border spinner-border-sm"
        ></span>
        <i *ngIf="exportingType !== 'original'" class="fas fa-file-excel"
          ><sup style="font-size: small; padding-left: 5px">®</sup></i
        >
      </button>

      <!-- Select righe per pagina -->
      <select
        class="form-select toolbar-select"
        [(ngModel)]="itemsPerPage"
        (change)="onItemsPerPageChange()"
        title="Numero righe"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>

      <!-- Bottone reset -->
      <button
        class="btn toolbar-btn toolbar-btn-reset"
        type="button"
        (click)="resetItemsPerPage()"
        title="Reset numero righe"
      >
        <i class="fa fa-undo"></i>
      </button>
    </div>
  </div>

  <!-- Errore filtri -->
  <div *ngIf="dateError" class="alert alert-warning mx-3">
    <div>
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ dateError }}</span>
    </div>
  </div>

  <!-- Tabella Colli -->
  <div *ngIf="!isLoading && parcels.length > 0">
    <div class="table-wrapper mx-3">
      <table class="table fixed-header-table table-hover">
        <thead class="bg-light">
          <tr>
            <ng-container *ngFor="let col of columns | orderBy: 'order'">
              <th
                *ngIf="
                  col.visible &&
                  (!col.specialOnly || canSpecial()) &&
                  (!col.updatableOnly || canUpdate())
                "
                [style.width]="col.width ? col.width : null"
                scope="col"
                [style.cursor]="col.sortable ? 'pointer' : 'default'"
                [class.sortable-header]="col.sortable"
                (click)="col.sortable ? setSort(col.field) : null"
              >
                {{ col.label | translate }}

                <i
                  *ngIf="col.sortable"
                  class="bi ms-1"
                  [ngClass]="{
                    'bi-arrow-up':
                      sortState.active === col.field &&
                      sortState.direction === 'asc',
                    'bi-arrow-down':
                      sortState.active === col.field &&
                      sortState.direction === 'desc',
                    'bi-arrow-down-up':
                      sortState.active !== col.field ||
                      sortState.direction === '',
                  }"
                >
                </i>
              </th>
            </ng-container>
          </tr>
        </thead>

        <tbody>
          <ng-container
            *ngFor="
              let p of filteredParcels
                | paginate
                  : {
                      id: 'parcel-pagination',
                      itemsPerPage: itemsPerPage,
                      currentPage: currentPage,
                      totalItems: totalRecords,
                    }
            "
          >
            <!--   (click)="toggleTrackings(p)" -->
            <tr style="cursor: pointer">
              <ng-container *ngFor="let col of columns | orderBy: 'order'">
                <td
                  *ngIf="
                    col.visible &&
                    (!col.specialOnly || canSpecial()) &&
                    (!col.updatableOnly || canUpdate())
                  "
                >
                  <!-- Render dinamico -->
                  <ng-container [ngSwitch]="col.field">
                    <span
                      *ngSwitchCase="'parcelWaybillStatus'"
                      class="status-indicator"
                      [ngClass]="{
                        'status-active': p.parcelWaybillStatus === 'ACTIVE',
                        'status-pending': p.parcelWaybillStatus === 'PENDING',
                        'status-unsent': p.parcelWaybillStatus === 'UNSENT',
                        'status-cancelled':
                          p.parcelWaybillStatus === 'CANCELLED' ||
                          p.parcelWaybillStatus === 'UNDEFINED' ||
                          p.parcelWaybillStatus === 'NOT_DELIVERED',
                        'status-delivered':
                          p.parcelWaybillStatus === 'DELIVERED',
                      }"
                    >
                      {{ p.parcelWaybillStatus }}
                    </span>

                    <!--  VGIIII -->
                    <span
                      *ngSwitchCase="'parcelDetailStatus'"
                      class="detail-status-indicator"
                      [ngClass]="{
                        'status-prepared': p.parcelDetailStatus === 'PREPARED',
                        'status-intriptotp':
                          p.parcelDetailStatus === 'IN_TRIP_TO_TP',
                        'status-intrip': p.parcelDetailStatus === 'IN_TRIP',
                        'status-closed': p.parcelDetailStatus === 'CLOSED',
                        'status-suspended':
                          p.parcelDetailStatus === 'SUSPENDED',
                      }"
                    >
                      <i
                        class="status-icon fas"
                        [ngClass]="{
                          'fa-box-open': p.parcelDetailStatus === 'PREPARED',
                          'fa-route': p.parcelDetailStatus === 'IN_TRIP_TO_TP',
                          'fa-truck-moving': p.parcelDetailStatus === 'IN_TRIP',
                          'fa-check-circle': p.parcelDetailStatus === 'CLOSED',
                          'fa-pause-circle':
                            p.parcelDetailStatus === 'SUSPENDED',
                        }"
                      ></i>

                      <span class="status-label">
                        {{ getParcelDetailStatusLabel(p.parcelDetailStatus) }}
                      </span>
                    </span>

                    <span *ngSwitchCase="'parcelWaybillOriginLocation'"
                      >{{ p.parcelWarehouseExternalCode }}
                      {{ p.parcelWaybillOriginLocation }}</span
                    >

                    <ng-container *ngSwitchCase="'parcelOriginalWaybillCode'">
                      <ng-container
                        *ngIf="
                          p.parcelClientCode === 'CLT00001';
                          else normalWaybill
                        "
                      >
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                        <!-- {{ (p.parcelOriginalWaybillCode ?? p.parcelWaybillCode)?.substring(2, 8)?.padStart(7, '0') }} -->
                      </ng-container>

                      <ng-template #normalWaybill>
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                      </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'parcelWaybillCode'">
                      {{
                        p.parcelOriginalWaybillCode ? p.parcelWaybillCode : ""
                      }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'parcelWaybillCodeFull'">
                      <ng-container *ngIf="p.parcelClientCode === 'CLT00001'">
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                      </ng-container>
                    </ng-container>

                    <!-- Date -->
                    <span *ngSwitchCase="'parcelDeliveryChangeCutoffDate'">
                      {{
                        p.parcelDeliveryChangeCutoffDate
                          | date: "dd/MM/yyyy HH:mm"
                      }}
                    </span>
                    <span *ngSwitchCase="'parcelDate'">{{
                      p.parcelDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                    <span *ngSwitchCase="'parcelDeliveryDate'">{{
                      p.parcelDeliveryDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                    <span *ngSwitchCase="'parcelEstimatedDeliveryDate'">{{
                      p.parcelEstimatedDeliveryDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>

                    <ng-container *ngSwitchCase="'parcelModifyManual'">
                      <button
                        *ngIf="
                          canSpecial() && p.parcelDeliveryDateIsForced != null
                        "
                        style="font-size: small"
                        class="btn btn-light"
                        type="button"
                        (click)="
                          viewDetailsModifiesManual(p); $event.stopPropagation()
                        "
                        title="Visualizza il dettaglio delle modifiche"
                      >
                        <i
                          *ngIf="p.parcelDeliveryDateIsUpdated === 'Y'"
                          class="fas fa-pencil-alt"
                          style="font-size: x-small"
                          title="Data modificata"
                        ></i>
                        <i
                          *ngIf="p.parcelDeliveryDateIsUpdated != 'Y'"
                          class="fa-solid fa-plus"
                          style="font-size: x-small"
                          title="Data aggiunta"
                        ></i>
                        {{
                          p.parcelModifyManual
                            ? (p.parcelModifyManual | date: "dd/MM/yyyy HH:mm")
                            : ""
                        }}
                      </button>
                    </ng-container>

                    <span
                      *ngSwitchCase="'parcelDeliveryChangeCutoffCountdown'"
                      [ngClass]="{
                        'cutoff-warning': p.parcelDeliveryChangeCutoffWarning,
                        'cutoff-expired': p.parcelDeliveryChangeCutoffExpired,
                      }"
                    >
                      {{ p.parcelDeliveryChangeCutoffCountdown || "" }}
                    </span>

                    <!-- Stato OnTime -->
                    <ng-container *ngSwitchCase="'parcelOnTime'">
                      <span
                        class="is-valid"
                        *ngIf="p.parcelOnTime === 'ON_TIME'"
                        >Si</span
                      >
                      <span
                        class="is-invalid"
                        *ngIf="p.parcelOnTime === 'NOT_ON_TIME'"
                        >No</span
                      >
                      <span
                        *ngIf="
                          p.parcelOnTime !== 'ON_TIME' &&
                          p.parcelOnTime !== 'NOT_ON_TIME'
                        "
                        >{{ p.parcelOnTime }}</span
                      >
                    </ng-container>

                    <!-- DeliveryMethod -->
                    <ng-container *ngSwitchCase="'parcelWaybillDeliveryMethod'">
                      <span *ngIf="p.parcelWaybillDeliveryMethod === 'BY_ROAD'"
                        >Via terra</span
                      >
                      <span *ngIf="p.parcelWaybillDeliveryMethod === 'BY_AIR'"
                        >Via aerea</span
                      >
                      <span
                        *ngIf="
                          p.parcelWaybillDeliveryMethod !== 'BY_ROAD' &&
                          p.parcelWaybillDeliveryMethod !== 'BY_AIR'
                        "
                      >
                        {{ p.parcelWaybillDeliveryMethod }}
                      </span>
                    </ng-container>

                    <!-- Coordinates -->
                    <ng-container *ngSwitchCase="'parcelLatitude'">
                      <span
                        [ngClass]="{
                          'is-invalid':
                            p.distanceInMeters != null &&
                            p.distanceInMeters > p.parcelWaybillMaximumRange,
                          'is-valid':
                            p.distanceInMeters != null &&
                            p.distanceInMeters <= p.parcelWaybillMaximumRange,
                        }"
                        >{{ p.parcelLatitude }}</span
                      >
                    </ng-container>
                    <ng-container *ngSwitchCase="'parcelLongitude'">
                      <span
                        [ngClass]="{
                          'is-invalid':
                            p.distanceInMeters != null &&
                            p.distanceInMeters > p.parcelWaybillMaximumRange,
                          'is-valid':
                            p.distanceInMeters != null &&
                            p.distanceInMeters <= p.parcelWaybillMaximumRange,
                        }"
                        >{{ p.parcelLongitude }}</span
                      >
                    </ng-container>

                    <!-- Distance -->
                    <ng-container *ngSwitchCase="'distanceInMeters'">
                      {{
                        p.distanceInMeters
                          ? (p.distanceInMeters | number: "1.0-0")
                          : ""
                      }}
                    </ng-container>

                    <!-- POD -->
                    <!-- <ng-container *ngSwitchCase="'pod'">
                                        <button *ngIf="p.isRestrictedClient === 'Y'" type="button" class="btn btn-sm btn-outline-primary"
                                            (click)="downloadPodDocument(p.parcelWaybillCode, p.waybillShipmentCode)"
                                            [disabled]="p.parcelDetailStatus != 'CLOSED'"
                                            matTooltip="Scarica POD">
                                            <i class="fas fa-file-pdf"></i>
                                        </button>
                                    </ng-container> -->

                    <!-- Azioni -->
                    <ng-container *ngSwitchCase="'actions'">
                      <button
                        *ngIf="
                          p.parcelWaybillStatus != 'PENDING' &&
                          p.parcelNotifiedStatus != 'SENT_TO_BMW' &&
                          p.parcelNotifiedStatus != 'VIEWED'
                        "
                        class="btn btn-sm btn-outline-primary ms-1"
                        (click)="openEditModal(p); $event.stopPropagation()"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        *ngIf="
                          p.parcelWaybillStatus != 'PENDING' &&
                          p.parcelNotifiedStatus != 'SENT_TO_BMW' &&
                          p.parcelNotifiedStatus != 'VIEWED' &&
                          p.parcelDeliveryStatus === 'DELIVERED'
                        "
                        class="btn btn-sm btn-outline-primary ms-1"
                        (click)="openRollbackModal(p); $event.stopPropagation()"
                        matTooltip="Annulla consegna"
                      >
                        <i class="fa-solid fa-undo"></i>
                      </button>
                    </ng-container>

                    <!-- Default -->
                    <span *ngSwitchDefault>{{ getValue(p, col.field) }}</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="!isLoading && !dateError && parcels.length === 0" class="mx-3">
    <div
      class="alert alert-warning d-flex align-items-center justify-content-between"
    >
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <span>Nessun collo trovato con i filtri selezionati.</span>
      </div>
      <!--tolto perché non applicava i filtri sopra -->
      <!-- <button class="action-btn primary" (click)="loadData()">
            <i class="fa fa-refresh me-1"></i>
            <span class="action-text">Riprova</span>
          </button> -->
    </div>
  </div>

  <!-- Pagination -->
  <pagination-controls
    *ngIf="totalRecords > 0"
    id="parcel-pagination"
    [maxSize]="5"
    [autoHide]="false"
    [responsive]="true"
    previousLabel="←"
    nextLabel="→"
    [(ngModel)]="currentPage"
    (pageChange)="onPageChange($event)"
    class="d-flex justify-content-end mt-3"
  >
  </pagination-controls>
</div>

<!-- Loader centrato -->
<div *ngIf="isLoading" class="loading-overlay">
  <div
    class="spinner-border text-primary"
    role="status"
    style="width: 4rem; height: 4rem"
  >
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>
<!-- Modal di rollback consegna -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showRollbackModal }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showRollbackModal"
  (click)="closeRollbackModal()"
>
  <div
    class="modal-dialog modal-md modal-dialog-centered"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Annulla consegna del collo {{ selectedParcel?.parcelCode }}
        </h5>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="!rollbackChoice; else confirmTpl">
          <p>
            Vuoi annullare la consegna di un singolo collo oppure dell’intera
            bolla?
          </p>
        </ng-container>
        <ng-template #confirmTpl>
          <p>
            Sei sicuro di voler procedere ad annullare la consegna
            {{
              rollbackChoice === "parcel"
                ? "del collo " + (selectedParcel?.parcelCode || "")
                : rollbackChoice === "waybill"
                  ? "dell'intera bolla " +
                    (selectedParcel?.parcelWaybillCode || "")
                  : ""
            }}?
          </p>
        </ng-template>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <ng-container *ngIf="!rollbackChoice; else footerConfirmTpl">
          <button class="btn btn-light" (click)="closeRollbackModal()">
            Chiudi
          </button>
          <div>
            <button
              class="btn btn-primary me-2"
              (click)="startRollback('parcel')"
            >
              Collo
            </button>
            <button class="btn btn-warning" (click)="startRollback('waybill')">
              Intera bolla ({{ numberParcelsOfWaybill }} colli)
            </button>
          </div>
        </ng-container>
        <ng-template #footerConfirmTpl>
          <button class="btn btn-light" (click)="cancelRollback()">
            Indietro
          </button>
          <div>
            <button class="btn btn-primary" (click)="confirmRollback()">
              OK
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Modal di modifica -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showModal }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showModal"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Modifica Collo</h5>
        <!-- <button type="button" class="btn-close" (click)="closeModal()"></button> -->
      </div>
      <div class="modal-body">
        <form>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Codice Collo</label>
              <input
                class="form-control"
                [value]="selectedParcel?.parcelCode"
                disabled
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Codice Bolla</label>
              <input
                class="form-control"
                [value]="selectedParcel?.parcelWaybillCode"
                disabled
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Data</label>
              <input
                class="form-control"
                type="datetime-local"
                [(ngModel)]="editForm.parcelDate"
                name="parcelDate"
                disabled
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Data Consegna</label>
              <!-- Caso RESTRICTED: mostra data/ora fissa + minuti editabili -->
              <!-- <ng-container *ngIf="selectedParcel?.isRestrictedClient == 'Y'; else normalDeliveryDateTpl">
                                    <input
                                    class="form-control"
                                    type="datetime-local"
                                    [(ngModel)]="editForm.parcelDeliveryDate"
                                    name="parcelDeliveryDate"
                                    disabled
                                    />

                                    <div class="mt-2 d-flex align-items-center justify-content-end gap-2">
                                    <label class="form-label mb-0" style="min-width: 40px;">Minuti</label>
                                    <input
                                        class="form-control"
                                        type="number"
                                        min="0"
                                        max="59"
                                        [ngModel]="restrictedMinutes"
                                        (ngModelChange)="onRestrictedMinutesChange($event)"
                                        name="restrictedMinutes"
                                        style="max-width: 65px;"
                                    />
                                    <small class="text-muted">0–59</small>
                                    </div>
                                </ng-container> -->

              <!-- Caso normale -->
              <!-- <ng-template #normalDeliveryDateTpl> -->
              <input
                class="form-control"
                type="datetime-local"
                [(ngModel)]="editForm.parcelDeliveryDate"
                name="parcelDeliveryDate"
                [disabled]="!!editChoice"
              />
              <!-- </ng-template> -->
              <!-- <input class="form-control" type="datetime-local" [(ngModel)]="editForm.parcelDeliveryDate"
                                   name="parcelDeliveryDate" [disabled]="!!editChoice" /> -->
            </div>

            <div class="col-md-6">
              <label class="form-label">Descrizione</label>
              <input
                class="form-control"
                [(ngModel)]="editForm.parcelDescription"
                name="parcelDescription"
                disabled
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Peso</label>
              <input
                class="form-control"
                type="number"
                [(ngModel)]="editForm.parcelWeight"
                name="parcelWeight"
                disabled
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Volume</label>
              <input
                class="form-control"
                type="number"
                [(ngModel)]="editForm.parcelVolume"
                name="parcelVolume"
                disabled
              />
            </div>
            <div class="col-md-3" *ngIf="editForm.parcelDeliveryDate != null">
              <label class="form-label">Latitudine</label>
              <input
                class="form-control"
                type="number"
                name="parcelLatitude"
                [(ngModel)]="editForm.parcelLatitude"
                (blur)="checkCoordinates()"
                [ngClass]="{
                  'is-invalid': !isCoordinatesCorrectSelectedParcel,
                }"
                [disabled]="!!editChoice"
              />
            </div>
            <div class="col-md-3" *ngIf="editForm.parcelDeliveryDate != null">
              <label class="form-label">Longitudine</label>
              <input
                class="form-control"
                type="number"
                name="parcelLongitude"
                [(ngModel)]="editForm.parcelLongitude"
                (blur)="checkCoordinates()"
                [ngClass]="{
                  'is-invalid': !isCoordinatesCorrectSelectedParcel,
                }"
                [disabled]="!!editChoice"
              />
            </div>
            <div
              class="col-md-3 d-flex align-items-end"
              *ngIf="
                editForm.parcelDeliveryDate != null &&
                !showButtonCreateCoordinates
              "
            >
              <button
                style="padding: 0.375rem 0.75rem; font-size: medium"
                type="button"
                class="btn btn-sm btn-outline-primary w-100"
                (click)="
                  calculateRandomCoordinates(selectedParcel);
                  $event.stopPropagation()
                "
                [disabled]="!!editChoice"
              >
                <i class="fa-solid fa-map-location-dot"></i> Calcola coordinate
              </button>
            </div>
            <div
              *ngIf="
                editForm.parcelDeliveryDate != null &&
                !isCoordinatesCorrectSelectedParcel
              "
              class="text-danger mt-2"
            >
              Le coordinate distano più di
              {{ selectedParcel?.parcelWaybillMaximumRange }} metri dal punto di
              consegna.
            </div>

            <!-- FIRMA -->
            <div
              class="col-12"
              *ngIf="
                editForm.parcelDeliveryDate != null &&
                selectedParcel?.clientRequestSignature == 'Y'
              "
            >
              <label class="form-label">Firma</label>

              <!-- PREVIEW firma già salvata -->
              <div *ngIf="showSavedSignatureOnly(); else drawSignatureBlock">
                <div class="mt-2">
                  <small class="text-muted d-block mb-1">Firma salvata</small>
                  <img
                    [src]="getSignatureImageSrc(parcelSignature)"
                    alt="Firma salvata"
                    class="signature-preview"
                  />
                </div>

                <div class="mt-2" *ngIf="!editChoice">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    (click)="enableSignatureEditing()"
                  >
                    Disegna nuova firma
                  </button>
                </div>
              </div>

              <!-- BLOCCO CANVAS -->
              <ng-template #drawSignatureBlock>
                <div
                  class="signature-wrapper"
                  [class.disabled-signature]="!!editChoice"
                >
                  <canvas
                    #signatureCanvas
                    class="signature-canvas"
                    [class.readonly]="!!editChoice"
                  >
                  </canvas>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center mt-2"
                >
                  <small class="text-muted"> Firma con mouse o touch </small>

                  <div class="d-flex gap-2">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm"
                      (click)="clearSignature()"
                      [disabled]="!!editChoice"
                    >
                      Pulisci firma
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      (click)="loadSavedSignature()"
                      [disabled]="!!editChoice || !parcelSignature"
                    >
                      Ripristina firma salvata
                    </button>
                  </div>
                </div>

                <div class="mt-2" *ngIf="signatureError">
                  <small class="text-danger">{{ signatureError }}</small>
                </div>

                <div class="mt-2" *ngIf="signaturePreview">
                  <small class="text-muted d-block mb-1"
                    >Anteprima firma acquisita</small
                  >
                  <img
                    [src]="signaturePreview"
                    alt="Firma"
                    class="signature-preview"
                  />
                </div>
              </ng-template>
            </div>
          </div>
        </form>
      </div>

      <!-- Messaggi di esito -->
      <div
        *ngIf="successDeliveryPropagation"
        class="alert alert-success mt-3 mx-3"
      >
        Propagazione avvenuta con successo su tutti i colli della bolla.
      </div>
      <div
        *ngIf="errorDeliveryPropagation"
        class="alert alert-danger mt-3 mx-3"
      >
        Errore durante la propagazione della data:
        {{ errorDeliveryPropagation }}
      </div>
      <div *ngIf="errorDeliveryNull" class="alert alert-danger mt-3 mx-3">
        Impossibile salvare con data di consegna nulla.
      </div>

      <div class="alert alert-warning mx-3 mb-0" *ngIf="editChoice as choice">
        <p class="mb-0">
          Sei sicuro di voler salvare
          {{
            choice === "parcel"
              ? "le modifiche per il collo " +
                (selectedParcel?.parcelCode || "")
              : "le modifiche per l'intera bolla " +
                (selectedParcel?.parcelWaybillCode || "")
          }}?
        </p>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <ng-container *ngIf="!editChoice; else footerConfirmEditTpl">
          <button class="btn btn-light" (click)="closeModal()">Chiudi</button>
          <div>
            <button
              class="btn btn-primary me-2"
              (click)="startEditSave('parcel')"
              [disabled]="
                !editForm.parcelDeliveryDate ||
                !coordinatesValid ||
                !isParcelChanged
              "
            >
              Aggiorna collo
            </button>
            <button
              class="btn btn-warning"
              (click)="startEditSave('waybill')"
              [disabled]="
                !editForm.parcelDeliveryDate ||
                !coordinatesValid ||
                !isParcelChanged
              "
            >
              Aggiorna intera bolla ({{ numberParcelsOfWaybill }} colli)
            </button>
          </div>
        </ng-container>
        <ng-template #footerConfirmEditTpl>
          <button class="btn btn-light" (click)="cancelEditConfirm()">
            Indietro
          </button>
          <div>
            <button
              class="btn btn-primary"
              (click)="confirmEditSave()"
              [disabled]="
                (editChoice === 'parcel' &&
                  (!coordinatesValid || !editForm.parcelDeliveryDate)) ||
                (editChoice === 'waybill' &&
                  (!coordinatesValid || !editForm.parcelDeliveryDate))
              "
            >
              OK
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="showNotification"
  class="alert alert-warning d-flex align-items-center justify-content-between"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    z-index: 1050;
  "
>
  <div>
    <i class="fas fa-exclamation-triangle me-2"></i>
    <span>{{ notificationMessage }}</span>
  </div>
</div>

<!-- Modal di dettaglio della modifica fatta -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showModalDetailModifies }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showModalDetailModifies"
>
  <div class="modal-dialog modal-data-modifica modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <b
            >Collo {{ selectedParcel?.parcelCode }}: dati originali e modificati
          </b>
        </h5>
      </div>
      <div class="modal-body">
        <!-- Sezione DATE -->
        <h6 class="mb-3">
          <i class="fa-solid fa-calendar-days"></i> Date di consegna
        </h6>
        <div class="table-responsive">
          <table class="table table-bordered align-middle text-center">
            <thead class="table-light">
              <tr>
                <th>Originale PTV</th>
                <th>Inviata</th>
                <th>Stimata</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    selectedParcel?.parcelOriginalDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelEstimatedDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  <ng-container
                    *ngIf="selectedParcel?.parcelDeliveryDateIsForced === 'Y'"
                  >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryDateIsUpdated === 'Y'
                      "
                      class="bi bi-pencil-fill text-primary"
                    >
                      Modificata</i
                    >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryDateIsUpdated !== 'Y'
                      "
                      class="bi bi-plus-circle-fill text-primary"
                    >
                      Aggiunta</i
                    >
                  </ng-container>
                  <ng-container
                    *ngIf="selectedParcel?.parcelDeliveryDateIsForced !== 'Y'"
                  >
                    <span class="text-muted">Nessuna modifica</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Sezione COORDINATE -->
        <h6 class="mt-4 mb-3">
          <i class="fa-solid fa-map-pin"></i> Coordinate di consegna
        </h6>
        <div class="table-responsive">
          <table class="table table-bordered align-middle text-center">
            <thead class="table-light">
              <tr>
                <th>Latitudine originale PTV</th>
                <th>Longitudine originale PTV</th>
                <th>Latitudine inviata</th>
                <th>Longitudine inviata</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    selectedParcel?.parcelOriginalLatitude !== null
                      ? selectedParcel?.parcelOriginalLatitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelOriginalLongitude !== null
                      ? selectedParcel?.parcelOriginalLongitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelLatitude !== null
                      ? selectedParcel?.parcelLatitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelLongitude !== null
                      ? selectedParcel?.parcelLongitude
                      : "—"
                  }}
                </td>
                <td>
                  <ng-container
                    *ngIf="
                      selectedParcel?.parcelDeliveryCoordinatesIsForced === 'Y'
                    "
                  >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryCoordinatesIsUpdated ===
                        'Y'
                      "
                      class="bi bi-pencil-fill text-primary"
                    >
                      Modificata</i
                    >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryCoordinatesIsUpdated !==
                        'Y'
                      "
                      class="bi bi-plus-circle-fill text-primary"
                    >
                      Aggiunta</i
                    >
                  </ng-container>
                  <ng-container
                    *ngIf="
                      selectedParcel?.parcelDeliveryCoordinatesIsForced !== 'Y'
                    "
                  >
                    <span class="text-muted">Nessuna modifica</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeModalDetailModifies()">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Import Excel -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showImportExcelModal }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showImportExcelModal"
  (click)="closeImportExcelModal()"
>
  <div
    class="modal-dialog modal-md modal-dialog-centered"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Importa Consegne da Excel</h5>
        <button
          class="btn btn-outline-success"
          (click)="downloadTemplateExcel()"
        >
          Scarica Excel Vuoto
        </button>
      </div>

      <div class="modal-body">
        <div class="mb-3">
          <input
            type="file"
            #fileInput
            hidden
            accept=".xlsx,.xls"
            (change)="onFileSelected($event)"
          />

          <button class="btn btn-primary w-100" (click)="fileInput.click()">
            Seleziona file dal tuo PC
          </button>
        </div>

        <div *ngIf="selectedExcelFile" class="alert alert-light">
          File selezionato:
          <strong>{{ selectedExcelFile.name }}</strong>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeImportExcelModal()">
          Chiudi
        </button>

        <button
          class="btn btn-primary"
          [disabled]="!selectedExcelFile"
          (click)="importExcelDeliveries()"
        >
          Importa Consegne
        </button>
      </div>
    </div>
  </div>
</div>
